import { NewPageList } from "./new-page-list";

export class Session {
    $key: string;

    name: string;
    location: string;
    position: number;

    sessionTopics = new Array();

    startTime: string;
    endTime: string;
    isEndTimeOnwards: boolean = false;

    isTea: boolean = false;
    isLunch: boolean = false;
    allowFeedback: boolean = false;



    description: string = null;
    hasChatroom: boolean = false;
    hasCustomDescription: boolean = false;
    hasDetailsScreen: boolean = false;
    hasHeader: boolean = false;
    headerType: string;
    hasPolls: boolean = false;
    isQuestionAllowed: boolean = false;
    youtubeUrl: string;
    headerContentMandatoryList = new Array<string>();

    aboutList = new Array<NewPageList>();

    hasDifferentVenue: boolean = false;
    showVenueTab: boolean = false;
    hideTopicTime: boolean = false;

    latitude: number;
    longitude: number;
    locationAddress: string;
    locationShort: string;


    speakerList = new Array<string>();
    chairpersonList = new Array<string>();
    coordinatorList = new Array<string>();

    hasAlternateSpeakerTitle: boolean = false;
    hasAlternateChairpersonTitle: boolean = false;
    hasAlternateCoordinatorTitle: boolean = false;

    alternateSpeakerTitle: string;
    alternateChairpersonTitle: string;
    alternateCoordinatorTitle: string;

    showSpeakerTab: boolean = true;
    showChairpersonTab: boolean = true;
    showCoordinatorTab: boolean = false;

    /* todo todo */
    venueName:string="";

    tracks = new Array<string>();
    types = new Array<string>();

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/core/models/session.ts